import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import Card from "./Card.js";
import Carousel from "../Carousels/Carousel.js";
import preventClick from "../../utils/PreventClick";

const HomePage = () => {

	const [INDEX, SET_INDEX] = useState(null);
	const NAVIGATE = useNavigate();

	useEffect(() => {
		fetch("./JSON/index.json")
			.then((response) => response.json())
			.then((data) => { SET_INDEX(data); });
	}, []);




	preventClick();


	return (

		<div className='homePage-background'>
			<div className='homePage-filter'>
				<h1>À la découverte du Nautré</h1>
				<p>Vivez une expérience interactive inédite au musée</p>
				<div className="homePage-carousel-block">
					{
						(INDEX === null) ?
							null
							:
							<Carousel classname={"menu"} items={INDEX.map((element) =>
								<Card
									key={element.id}
									image={element.miniature}
									title={element.title}
									description={element.description}
									onClick={
										() => {
											(element.state === "exploration") ?
												NAVIGATE("/libre", { replace: false, state: element.json })
												:
												NAVIGATE("/narratif", { replace: false, state: element.json });
										}
									} />
							)} nbItemsToDisplay={3} />
					}
				</div>
				<button className="home-button-credit" onClick={() => NAVIGATE("/credit")}>crédits</button>
			</div>
		</div>
	);
};

export default HomePage;